var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 38.0001C8 41.0001 8 33.0001 4 32.0001M32 44.0001V36.2601C32.075 35.3064 31.9462 34.3477 31.622 33.4477C31.2979 32.5477 30.7859 31.727 30.12 31.0401C36.4 30.3401 43 27.9601 43 17.0401C42.9995 14.2478 41.9254 11.5625 40 9.54012C40.9117 7.09713 40.8472 4.39682 39.82 2.00012C39.82 2.00012 37.46 1.30012 32 4.96012C27.416 3.71776 22.584 3.71776 18 4.96012C12.54 1.30012 10.18 2.00012 10.18 2.00012C9.15275 4.39682 9.08829 7.09713 10 9.54012C8.06025 11.5775 6.98505 14.287 7 17.1001C7 27.9401 13.6 30.3201 19.88 31.1001C19.222 31.7801 18.7145 32.5909 18.3906 33.48C18.0667 34.369 17.9336 35.3163 18 36.2601V44.0001",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.f6aa2f469f0fc53253925bfd71032cc1.svg";
export { ForwardRef as ReactComponent };